"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Stack = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const Stack = ({ children, id, direction = 'row', style, className, wrap = false }) => {
    const wrapStyle = wrap ? 'wrap' : 'nowrap';
    const flexFlow = `${direction} ${wrapStyle}`;
    return ((0, jsx_runtime_1.jsx)("div", Object.assign({ id: id, className: className, style: Object.assign({ display: 'flex', flexFlow }, style) }, { children: children })));
};
exports.Stack = Stack;
//# sourceMappingURL=index.js.map